/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from 'react';
import { MdUpload } from 'react-icons/md';
import { ProductUploadProps } from '../../@types';
import styles from './ContentUpload.module.scss';

export const ContentUpload = memo(({ error, tableData, uploadBoxTitle, uploadBoxSubtitle, table, onClickOpenModalUpload }: ProductUploadProps) => {
  const uploadBoxClass = error ? 'upload-box-error' : 'upload-box';
  const uploadBoxClassContent = error ? 'upload-content-error' : 'upload-content';
  const uploadBoxClassTitle = error ? 'upload-title-error' : 'upload-title';
  const uploadBoxClassSubtitle = error ? 'upload-description-error' : 'upload-description';

  const hasTableData = tableData && tableData[0]?.dataEnvio && tableData.length > 0 ? table : null;

  return (
    <div className={styles[uploadBoxClass]} role="button" tabIndex={0} style={{ cursor: 'pointer' }}>
      <div className={styles[uploadBoxClassContent]} onClick={onClickOpenModalUpload}>
        <h3 className={styles[uploadBoxClassTitle]}>
          {uploadBoxTitle}
          <MdUpload className={styles.uploadIcon} />
        </h3>
        <p className={styles[uploadBoxClassSubtitle]}>{uploadBoxSubtitle}</p>
      </div>
      {hasTableData}
    </div>
  );
});
